/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
// import MetaTags from "react-meta-tags";
import {
  Button,
  Col,
  Divider,
  Input,
  Row,
  Select,
  Modal,
  Upload,
  Tooltip,
  Image,
  Typography,
  Switch,
  Radio,
  message,
  // Skeleton,
} from "antd";
import {
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  BarsOutlined,
  PercentageOutlined,
  CloseOutlined,
  CloudUploadOutlined,
  InfoCircleOutlined,
  DatabaseFilled,
  EyeFilled,
  EyeInvisibleFilled,
  // TruckFilled,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import { BiCalendar, BiQrScan } from "react-icons/bi";
import moment from "moment/moment";
import { Prompt } from "react-router";
import { isEmpty } from "lodash";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import useBeforeUnload from "../../components/Prompting";
import customModalLogo from "../../assets/images/custom-field-banner.webp";
import customFieldsLogo from "../../assets/images/item_custom_fields.svg";
import {
  createBrandList,
  // createItemList,
  loadBrandList,
  // loadCategory,
  loadItems,
  loadItemsRecordsMetaData,
  // updateItemList,
} from "../../store/items/actions";
import DatePicker from "react-datepicker";
import "./index.css";
import { itemList } from "./data";
import api from "../../helpers";
import useMedia from "use-media-antd-query";
const { Dragger } = Upload;

const CreateItems = (props) => {
  //Custom Fields State values
  const dispatch = useDispatch();
  const media = useMedia();
  //validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";

  const profileName =
    props.location && props.location.state
      ? props.location.state.user.organizations[0].organizationId
      : "";

  const updatedData = props && props.data && props.data ? props.data : "";
  const organizationId = !isEmpty(userInfoDetails)
    ? userInfoDetails
    : profileName;
  const itemListId = { organizationId: organizationId };

  //Custom Fields State values
  const [customFields, setCustomFields] = useState(false);
  const [itemSettings, setItemSettings] = useState(false);
  const [pageRender, setPageRender] = useState(false);
  const [invoiceShow, setInvoiceShow] = useState(false);
  const [stockValue, setStockValue] = useState([]);
  const [itemBatching, setItemBatching] = useState("");
  const [beforeExpiry, setBeforeExpiry] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [validity, setValidity] = useState([]);
  const [serialNumberFields, setSerialNumberFields] = useState("");
  const [createItemModal, setCreateItemModal] = useState(false);

  const handleOk = () => {
    setCustomFields(false);
  };
  const handleCancel = () => {
    setCustomFields(false);
  };

  //api loader
  useEffect(() => {
    // dispatch(loadCategory(itemListId));
    dispatch(loadBrandList());
    if (props.routeName === "PurchaseOrders") {
      dispatch(loadItemsRecordsMetaData());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const {
    brand_list = [],
    // category_list = [],
    recordsMetaData = {},
  } = useSelector((state) => state.Items);

  const brandOptions =
    brand_list.length > 0
      ? brand_list.map((c) => {
          return {
            label: c.brandName,
            shortCode: c.shortCode,
            value: c._id,
          };
        })
      : [];
  // const categoryOptions =
  //   category_list.length > 0
  //     ? category_list.map((c) => {
  //         return {
  //           label: c.categoryName,
  //           shortCode: c.shortCode,
  //           value: c._id,
  //         };
  //       })
  //     : [];

  //Select Categories
  const [itemCategory, setItemCategory] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [description, setDescription] = useState("");
  const [shortCode, setShortCode] = useState("");
  const [categoryValidations, setCategoryValidations] = useState(false);
  const [itemCategoryModal, setItemCategoryModal] = useState(false);
  const [categoryAdditionalFields, setCategoryAdditionalFields] = useState("");

  //Item creations State values

  const [itemDetailsData, setItemDetailsData] = useState({
    _id: "",
    itemName: "",
    salesPrice: "",
    pricingPurchase: "",
    openingStocks: "",
    batchNo: "",
    itemCode: "",
    hsnCode: "",
    conversionsRate: "",
    lowStockQuantity: "",
    description: "",
    sacCode: "",
    serviceCode: "",
    serviceDescription: "",
  });

  const handleItemChange = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      salesPrice: /^[0-9]*$/,
      pricingPurchase: /^[0-9]*$/,
    };
    if (validationRules[name]) {
      if (validationRules[name].test(value) || value === "") {
        setItemDetailsData({
          ...itemDetailsData,
          [name]: value,
        });
      }
    } else {
      setItemDetailsData({
        ...itemDetailsData,
        [name]: value,
      });
    }
  };

  const [salesPriceMode, setSalesPriceMode] = useState([]);
  const [measuringUnit, setMeasuringUnit] = useState([]);
  const [secondaryMeasuringUnit, setSecondaryMeasuringUnit] = useState([]);
  const [showOnlineStore, setShowOnlineStore] = useState(false);

  const [menuSelected, setMenuSelected] = useState("Basic Details");
  const [itemType, setItemType] = useState("Product");
  const [batching, setBatching] = useState("");
  // const [gstType, setGstType] = useState([]);
  const [gstRate, setGstRate] = useState([]);
  const [serialisation, setSerialisation] = useState("");

  //Stock details input
  const [asOfDate, setAsOfDate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [mfgDate, setMfgDate] = useState("");
  const [alternativeUnit, setAlternativeUnit] = useState(false);
  const [lowStock, setLowStock] = useState(false);

  const [fileList, setFileList] = useState([]);
  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const draggerProps = {
    name: "file",
    multiple: true,
    action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        // console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      }
    },
    onDrop(e) {
      // console.log("Dropped files", e.dataTransfer.files);
    },
  };

  //Serialisation
  const [serialOpenStock, setSerialOpenStock] = useState("");
  const [serialData, setSerialData] = useState([
    {
      serialNo: "",
      date: moment().format("Do MMM YYYY"),
    },
  ]);

  const addSerialData = () => {
    setSerialData([
      ...serialData,
      {
        serialNo: "",
        date: moment().format("Do MMM YYYY"),
      },
    ]);
    // setSerialDataAdd(true);
    setPageRender(!pageRender);
  };

  const removeSerialData = (index) => {
    const array = serialData;
    if (index !== 0) {
      if (index > -1) {
        array.splice(index, 1);
        setSerialOpenStock(array.length);
        // if (array.length === 1) {
        //   setSerialData([
        //     ...serialData,
        //     {
        //       serialNo: "",
        //     },
        //   ]);
        // }
      }
    }
    setPageRender(!pageRender);
  };

  const handleSerialDataChange = (e, name, index) => {
    var fieldList = serialData;
    if (name === "serialNo") {
      fieldList[index][name] = e.target.value;
      setSerialData(fieldList);

      // if (fieldList.length > 0 && !isEmpty(fieldList[0].serialNo)) {
      setSerialOpenStock(fieldList.length);
      // }
      setPageRender(!pageRender);
    }
  };

  const [customFieldsData, setCustomFieldsData] = useState([
    {
      fieldName: "",
    },
  ]);

  const addCustomFields = () => {
    setCustomFieldsData([
      ...customFieldsData,
      {
        fieldName: "",
      },
    ]);
    // setCustomFieldsAdd(true);
    setPageRender(!pageRender);
  };

  const removeCustomFields = (index) => {
    const array = customFieldsData;
    if (index !== 0) {
      if (index > -1) {
        array.splice(index, 1);
      }
    }
    setPageRender(!pageRender);
  };

  const handleCustomFieldsChange = (e, name, index) => {
    var fieldList = customFieldsData;
    if (name === "fieldName") {
      fieldList[index][name] = e.target.value;
      setCustomFieldsData(fieldList);
      setPageRender(!pageRender);
    }
  };

  useEffect(() => {
    setStockValue({
      value: "Purchase Price",
      label: "Purchase Price",
    });
    setSerialNumberFields("IMEI/Serial No");
    setSalesPriceMode("With Tax");
    if (props.modalOpen) {
      setCreateItemModal(true);
    }
    if (props.mode !== "Update") {
      setItemDetailsData({
        _id: "",
        itemName: "",
        salesPrice: "",
        pricingPurchase: "",
        openingStocks: "",
        batchNo: "",
        itemCode: "",
        hsnCode: "",
        conversionsRate: "",
        lowStockQuantity: "",
        description: "",
        sacCode: "",
        serviceCode: "",
        serviceDescription: "",
      });
      setItemCategory([]);
      setBrandList([]);
      setCategoryName("");
      setDescription("");
      setShortCode("");
      // setSalesPriceMode([]);
      setMeasuringUnit([]);
      setSecondaryMeasuringUnit([]);

      setMenuSelected("Basic Details");
      const itemTypes =
        !isEmpty(updatedData) &&
        updatedData !== undefined &&
        updatedData.isProduct === true
          ? "Product"
          : !isEmpty(updatedData) &&
            updatedData !== undefined &&
            updatedData.isService === true
          ? "Service"
          : [];
      setItemType(itemTypes);
      setBatching("");
      setGstRate([]);
      setSerialisation("");

      //Stock details input
      setAsOfDate("");
      setExpiryDate("");
      setMfgDate("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  //create item objects
  const itemListData = {
    organizationId: organizationId,
    brandId: brandList,
    categoryId: "",
    categoryName: "",
    // categoryId: categoryId ? categoryId : "",
    // categoryName: itemCategory ? itemCategory : "",
    itemName: itemDetailsData.itemName,
    salesPrice: itemDetailsData.salesPrice,
    purchasePrice: itemDetailsData.pricingPurchase,
    isProduct: itemType == "Product" ? true : false,
    isService: itemType == "Service" ? true : false,
    withTax: salesPriceMode === "With Tax" ? true : false,
    // gstTypeId: gstType,
    gstPercentageId:
      !isEmpty(gstRate) || (gstRate && gstRate.length > 0) ? gstRate : "",
    measuringId:
      !isEmpty(measuringUnit) || (measuringUnit && measuringUnit.length > 0)
        ? measuringUnit
        : "",
    secondarymeasuringId:
      !isEmpty(secondaryMeasuringUnit) ||
      (secondaryMeasuringUnit && secondaryMeasuringUnit.length > 0)
        ? secondaryMeasuringUnit
        : "",
    itemCode: itemDetailsData.itemCode,
    barCode: itemDetailsData.hsnCode,
    HSNCode: itemDetailsData.hsnCode,
    conversionRate: itemDetailsData.conversionsRate,
    openingStock: itemDetailsData.openingStocks,
    AsofDate: asOfDate,
    description: itemDetailsData.description,
    image: fileList.length > 0 ? fileList : "",
    createdBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    customFields:
      customFieldsData.length > 0 && !isEmpty(customFieldsData[0].fieldName)
        ? customFieldsData.map((data) => {
            return {
              name: data.fieldName,
              descriptionoramount: "200",
            };
          })
        : [],
    //    serial is enable
    serialMeasuringId:
      !isEmpty(measuringUnit) || (measuringUnit && measuringUnit.length > 0)
        ? measuringUnit
        : "",
    serialOpeningStock: itemDetailsData.serialOpenStocks,
    serialDetails:
      serialData.length > 0 && !isEmpty(serialData[0].serialNo)
        ? serialData.map((data) => {
            return {
              serialNo: data.serialNo,
              dateCreated: data.date,
            };
          })
        : [],
    isBatching: batching === true ? true : false,
    isSerialization: serialisation === true ? true : false,
  };

  //Updated values fron edit
  const brandIdValue =
    !isEmpty(updatedData) && brandOptions.length > 0
      ? brandOptions.find((data) => data.label === brandList)
      : "";
  const brandId = !isEmpty(brandIdValue) ? brandIdValue.value : "";

  //update item objects
  const itemUpdateList = {
    itemId: itemDetailsData._id,
    brandId: brandList ? brandList : brandId,
    organizationId: organizationId,
    categoryId: "",
    categoryName: "",
    // categoryId: categoryId ? categoryId : "",
    // categoryName: itemCategory ? itemCategory : "",
    itemName: itemDetailsData.itemName,
    isProduct: itemType == "Product" ? true : false,
    isService: itemType == "Service" ? true : false,
    salesPrice: itemDetailsData.salesPrice,
    purchasePrice: itemDetailsData.pricingPurchase,
    withTax: salesPriceMode === "With Tax" ? true : false,
    // gstTypeId: gstType,
    gstPercentageId:
      !isEmpty(gstRate) || (gstRate && gstRate.length > 0) ? gstRate : "",
    measuringId:
      !isEmpty(measuringUnit) || (measuringUnit && measuringUnit.length > 0)
        ? measuringUnit
        : "",
    secondarymeasuringId:
      !isEmpty(secondaryMeasuringUnit) ||
      (secondaryMeasuringUnit && secondaryMeasuringUnit.length > 0)
        ? secondaryMeasuringUnit
        : "",
    itemCode:
      itemDetailsData.itemCode !== undefined ||
      !isEmpty(itemDetailsData.itemCode)
        ? itemDetailsData.itemCode
        : "",
    barCode:
      itemDetailsData.itemCode !== undefined ||
      !isEmpty(itemDetailsData.itemCode)
        ? itemDetailsData.itemCode
        : "",
    HSNCode: itemDetailsData.hsnCode,
    conversionRate: itemDetailsData.conversionsRate,
    openingStock: itemDetailsData.openingStocks,
    AsofDate: asOfDate,
    description: itemDetailsData.description,
    image: fileList.length > 0 ? fileList : "",
    createdBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    customFields:
      customFieldsData.length > 0 && !isEmpty(customFieldsData[0].fieldName)
        ? customFieldsData.map((data) => {
            return {
              name: data.fieldName,
              descriptionoramount: "200",
            };
          })
        : [],
    //    serial is enable
    serialMeasuringId:
      !isEmpty(measuringUnit) || (measuringUnit && measuringUnit.length > 0)
        ? measuringUnit
        : "",
    serialOpeningStock: itemDetailsData.serialOpenStocks,
    serialDetails:
      serialData.length > 0 && !isEmpty(serialData[0].serialNo)
        ? serialData.map((data) => {
            return {
              serialNo: data.serialNo,
              dateCreated: data.date,
            };
          })
        : [],
    isBatching: batching === true ? true : false,
    isSerialization: serialisation === true ? true : false,
  };

  const itemListObj = Object.keys(itemListData).forEach(
    (k) =>
      (itemListData[k] == "" || itemListData[k] == undefined) &&
      delete itemListData[k]
  );
  const itemUpdateListObj = Object.keys(itemUpdateList).forEach(
    (k) =>
      (itemUpdateList[k] == "" || itemUpdateList[k] == undefined) &&
      delete itemUpdateList[k]
  );

  console.log(itemListData, "itemListData");
  console.log(itemListObj, "itemListObj");
  console.log(itemUpdateList, "itemUpdateList");
  console.log(itemUpdateListObj, "itemUpdateListObj");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  //create items list
  const createItems = () => {
    if (simpleValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 5000);
      api
        .post("/org/createitem", itemListData)
        .then((res) => {
          dispatch(loadItems(itemListId));
          toast.success("Items Added Successfully");
          setTimeout(() => {
            handleCreateItemModal();
            props.itemCreated(true);
          }, 1500);
          return res.data;
        })
        .catch((error) => {
          console.log(error, "error");
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          toast.error(errorMsg || "An Error while adding the items");
          return Promise.reject(error);
        });
      // dispatch(createItemList(itemListData));
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  //create items list
  const updateItems = () => {
    if (simpleValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 5000);
      // dispatch(updateItemList(itemUpdateList));
      api
        .put("/org/updateitem", itemUpdateList)
        .then((res) => {
          dispatch(loadItems(itemListId));
          toast.success("Items Updated Successfully");
          props.updatedItemValues(itemDetailsData._id);
          setTimeout(() => {
            handleCreateItemModal();
            props.itemCreated(true);
          }, 1500);
          return res.data;
        })
        .catch((error) => {
          console.log(error, "error");
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          toast.error(errorMsg || "An Error while updating the items");
          return Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const handleCreateItemModal = () => {
    setCreateItemModal(false);
    props.modalClose(false);
  };

  const [isCategoryButtonDisabled, setIsCategoryButtonDisabled] =
    useState(false);
  //category api integrations
  const createCategory = () => {
    if (!isEmpty(categoryName)) {
      setIsCategoryButtonDisabled(true);
      setTimeout(() => {
        setIsCategoryButtonDisabled(false);
      }, 5000);
      const categoryList = {
        brandName: categoryName,
        // organizationId: organizationId,
        // shortCode: shortCode,
        // description: description,
        // createdBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
      };

      dispatch(createBrandList(categoryList));
      setTimeout(() => {
        dispatch(loadBrandList());
        setItemCategoryModal(false);
        setCategoryValidations(false);
        // toast.success();
      }, 1000);
    } else {
      setCategoryValidations(true);
    }
  };

  useBeforeUnload({
    when: !isEmpty(asOfDate),
    message: "Are you sure you want to leave?",
  });

  console.log(updatedData, "updatedData");

  //updated data's from item selections
  useEffect(() => {
    if (!isEmpty(updatedData)) {
      // const gstPercentageId =
      //   updatedData && updatedData.gstPercentageId
      //     ? updatedData.gstPercentageId
      //     : [];
      const gstPercentageName =
        updatedData && updatedData.gstPercentageName
          ? updatedData.gstPercentageName
          : [];
      const measuringName =
        updatedData && updatedData.measuringName
          ? updatedData.measuringName
          : [];
      // const categoryId =
      //   updatedData && updatedData.categoryId ? updatedData.categoryId : [];
      const categoryName =
        updatedData && updatedData.categoryName ? updatedData.categoryName : [];

      const itemType =
        updatedData && updatedData.isProduct === true
          ? "Product"
          : updatedData && updatedData.isService === true
          ? "Service"
          : [];
      setItemCategory(categoryName);
      setItemType(itemType);
      setBrandList(updatedData.brandId);
      setGstRate(gstPercentageName);
      setMeasuringUnit(measuringName);

      setItemDetailsData({
        _id: updatedData && updatedData._id ? updatedData._id : "",
        itemName:
          updatedData && updatedData.itemName ? updatedData.itemName : "",
        itemCode:
          updatedData && updatedData.itemCode ? updatedData.itemCode : "",

        batchNo: "",
        openingStocks:
          updatedData && updatedData.openingStock
            ? updatedData.openingStock
            : "",
        hsnCode: updatedData && updatedData.HSNCode ? updatedData.HSNCode : "",
        salesPrice:
          updatedData && updatedData.salesPrice ? updatedData.salesPrice : "",
        pricingPurchase:
          updatedData && updatedData.purchasePrice
            ? updatedData.purchasePrice
            : "",
        conversionsRate: "",
        lowStockQuantity: "",
        description: "",
        sacCode: "",
        serviceCode: "",
        serviceDescription: "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedData]);

  return (
    <div>
      {/* Create item modal */}
      <Modal
        open={createItemModal}
        title={
          props.mode === "Update" ? "Update Create Item" : "Create New Item"
        }
        onOk={() => {
          if (props.mode === "Update") {
            updateItems();
          } else {
            createItems();
          }
        }}
        closeIcon
        maskClosable={false}
        okText={props.mode === "Update" ? "Update" : "Save"}
        okButtonProps={{
          disabled: isButtonDisabled
            ? true
            : !isEmpty(itemDetailsData.itemName) &&
              itemType &&
              itemCategory &&
              !isButtonDisabled
            ? false
            : true,
        }}
        style={{
          fontFamily: "Poppins",
        }}
        width={850}
        height={"100%"}
        className="mt-[-90px]"
        onCancel={() => {
          handleCreateItemModal();
        }}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
      >
        <Divider
          style={{
            borderWidth: "0.2px",
            width: "105.9%",
            marginLeft: "-24px",
          }}
        />
        <Col span={24}>
          <Row>
            <Col
              span={6}
              className="h-[350px] border border-gray-200 rounded-md p-4"
            >
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className={
                  menuSelected === "Basic Details"
                    ? "bg-[#8d8d8d26] pt-[5px] pb-[5px] pl-[5px] pr-[4px] flex border rounded-md text-[#063b91] cursor-pointer mb-[-4px]"
                    : "flex pt-[5px] pb-[5px] hover:rounded-md hover:bg-gray-200 pl-[5px] pr-[4px] cursor-pointer mb-[-4px]"
                }
                onClick={() => setMenuSelected("Basic Details")}
              >
                <DatabaseFilled className="mt-[1px]" />
                <h1 className="ml-2 flex text-[14px] mb-[-4px]">
                  Basic Details <p className="ml-2 text-[red] text-[12px]">*</p>
                </h1>
              </div>
              {batching === true && itemType !== "Service" ? (
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className={
                    menuSelected === "Batch Details"
                      ? "bg-[#8d8d8d26] mt-4 pt-[5px] pb-[5px] pl-[5px] pr-[4px] flex border rounded-md text-[#063b91] cursor-pointer mb-[-4px]"
                      : "flex pt-[5px] mt-4 pb-[5px] hover:rounded-md hover:bg-gray-200 pl-[5px] pr-[4px] cursor-pointer mb-[-4px]"
                  }
                  onClick={() => setMenuSelected("Batch Details")}
                >
                  <BarsOutlined className="mt-[1px]" />
                  <h1 className="ml-2 flex text-[14px] mb-[-4px]">
                    Batch Details
                  </h1>
                </div>
              ) : (
                ""
              )}
              {serialisation === true ? (
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className={
                    menuSelected === "Serialisation"
                      ? "bg-[#8d8d8d26] mt-4 pt-[5px] pb-[5px] pl-[5px] pr-[4px] flex border rounded-md text-[#063b91] cursor-pointer mb-[-4px]"
                      : "flex pt-[5px] mt-4 pb-[5px] hover:rounded-md hover:bg-gray-200 pl-[5px] pr-[4px] cursor-pointer mb-[-4px]"
                  }
                  onClick={() => setMenuSelected("Serialisation")}
                >
                  <PercentageOutlined className="mt-[1px]" />
                  <h1 className="ml-2 flex text-[14px] mb-[-4px]">
                    Serialization{" "}
                  </h1>
                </div>
              ) : (
                false
              )}

              <Divider
                style={{
                  borderWidth: "0.2px",
                  width: "119%",
                  marginLeft: "-17px",
                }}
              />

              <div className="font-semibold mt-[-2px] mb-2">
                Advance Details
              </div>
              {itemList.map((data, index) => {
                return (
                  <>
                    {data.type !== "service" && itemType === "Product" ? (
                      <div
                        style={{
                          fontFamily: "Poppins",
                          opacity: 2,
                        }}
                        className={
                          menuSelected === data.label
                            ? "flex bg-[#8d8d8d26] mt-4 mb-2 pt-[5px] pb-[5px] pl-[5px] pr-[4px] rounded-md text-[#063b91] cursor-pointer"
                            : isEmpty(itemDetailsData.itemName)
                            ? "pointer-events-none opacity-1 flex hover:bg-gray-200 hover:rounded-md mt-4 mb-2 pt-[4px]  pb-[3px] pl-[5px] pr-[3px]"
                            : "flex hover:bg-gray-200 hover:rounded-md mt-4 mb-2 pt-[4px]  pb-[3px] pl-[5px] pr-[3px] cursor-pointer"
                        }
                        key={index}
                        onClick={() => setMenuSelected(data.label)}
                      >
                        {" "}
                        <p className="mt-[1px]">{data.icon}</p>
                        <h1 className="ml-2 text-[14px]">{data.label}</h1>
                      </div>
                    ) : data.type === "service" && itemType === "Service" ? (
                      <div
                        style={{
                          fontFamily: "Poppins",
                          opacity: 2,
                        }}
                        className={
                          menuSelected === data.label
                            ? "flex bg-[#8d8d8d26] mt-4 mb-2 pt-[5px] pb-[5px] pl-[5px] pr-[4px] rounded-md text-[#063b91] cursor-pointer"
                            : isEmpty(itemDetailsData.itemName)
                            ? "pointer-events-none opacity-1 flex hover:bg-gray-200 hover:rounded-md mt-4 mb-2 pt-[4px]  pb-[3px] pl-[5px] pr-[3px]"
                            : "flex hover:bg-gray-200 hover:rounded-md mt-4 mb-2 pt-[4px]  pb-[3px] pl-[5px] pr-[3px] cursor-pointer"
                        }
                        key={index}
                        onClick={() => setMenuSelected(data.label)}
                      >
                        {" "}
                        <p className="mt-[1px]">{data.icon}</p>
                        <h1 className="ml-2 text-[14px]">{data.label}</h1>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
            </Col>

            {/* Component of items */}
            <Col
              span={17}
              className={
                menuSelected === "Basic Details"
                  ? "items-basic-details-card ml-3 pr-2 border border-gray-200 rounded-md p-4"
                  : menuSelected === "Stock Details"
                  ? "items-stock-details-card ml-3 pr-2 border border-gray-200 rounded-md p-4"
                  : "ml-3 h-[100%] border border-gray-200 rounded-md p-4"
              }
            >
              {menuSelected === "Custom Fields" ? (
                <div className="w-[100%] h-[262px] mt-[10%]">
                  <div
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="text-center"
                  >
                    <Image
                      className="text-center"
                      src={customFieldsLogo}
                      preview={false}
                    />
                    <h1 className="text-center">
                      You don't have any custom fields created yet
                    </h1>

                    <div
                      onClick={() => setItemSettings(true)}
                      className="mt-3 flex justify-center"
                      style={{
                        pointerEvents: !isEmpty(updatedData) ? "none" : "",
                        opacity: !isEmpty(updatedData) ? 2 : "",
                      }}
                    >
                      <div className="rounded-md cursor-pointer bg-[#e7f4fd] p-2 hover:border hover:border-blue-500 text-[#0c8ce9]">
                        <PlusOutlined className="mr-1" />
                        Create Custom Fields
                      </div>
                    </div>
                  </div>
                </div>
              ) : menuSelected === "Pricing Details" ? (
                <Col
                  style={{
                    pointerEvents: !isEmpty(updatedData) ? "none" : "",
                    opacity: !isEmpty(updatedData) ? 2 : "",
                  }}
                  span={24}
                >
                  <Row className="mt-3">
                    <Col span={12} className="pr-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        Sales Price
                      </Typography>

                      <Input
                        name="salesPrice"
                        value={itemDetailsData.salesPrice}
                        onChange={(e) => handleItemChange(e)}
                        addonAfter={
                          <Select
                            value={salesPriceMode}
                            onChange={(e) => setSalesPriceMode(e)}
                            defaultValue={"With Tax"}
                            style={{
                              width: 130,
                              height: 40,
                            }}
                            options={[
                              {
                                label: "With Tax",
                                value: "With Tax",
                              },

                              {
                                label: "Without Tax",
                                value: "Without Tax",
                              },
                            ]}
                          />
                        }
                        type="text"
                        prefix={"₹ "}
                        placeholder="ex: ₹100"
                        className="pb-[10px] pt-1"
                        // style={{
                        //   padding: "12px"
                        // }}
                      />
                    </Col>
                    <Col span={12} className="pr-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-2 flex"
                      >
                        Purchase Price
                      </Typography>

                      <Input
                        name="pricingPurchase"
                        value={itemDetailsData.pricingPurchase}
                        onChange={(e) => handleItemChange(e)}
                        addonAfter={
                          <Select
                            value={salesPriceMode}
                            onChange={(e) => setSalesPriceMode(e)}
                            defaultValue={"With Tax"}
                            style={{
                              width: 130,
                              height: 40,
                            }}
                            options={[
                              {
                                label: "With Tax",
                                value: "With Tax",
                              },

                              {
                                label: "Without Tax",
                                value: "Without Tax",
                              },
                            ]}
                          />
                        }
                        type="text"
                        prefix={"₹ "}
                        placeholder="ex: ₹100"
                      />
                    </Col>
                    <Col span={12} className="pr-4 mt-3">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] font-poppins mb-1"
                      >
                        GST Tax Rate(%)
                      </Typography>
                      <Select
                        placeholder="Select Tax"
                        className="h-[40px] w-[100%]"
                        value={gstRate}
                        onChange={(e) => setGstRate(e)}
                        options={
                          recordsMetaData
                            ? recordsMetaData.gstPercentageOptions
                            : ""
                        }
                      />
                    </Col>
                  </Row>
                </Col>
              ) : menuSelected === "Batch Details" &&
                batching === true &&
                itemType !== "Service" ? (
                <Col
                  style={{
                    pointerEvents: !isEmpty(updatedData) ? "none" : "",
                    opacity: !isEmpty(updatedData) ? 2 : "",
                  }}
                  span={24}
                >
                  <Row className="mt-3">
                    <Col span={12} className="pr-4 mb-2">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        Batch No
                      </Typography>

                      <Input
                        name="batchNo"
                        value={itemDetailsData.batchNo}
                        onChange={(e) => handleItemChange(e)}
                        type="text"
                        className="p-2"
                        placeholder="Batch #1"
                      />
                    </Col>
                    <Col span={12} className="pr-4 mb-2">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1"
                      >
                        Measuring Unit
                      </Typography>
                      <Select
                        placeholder="Select Unit"
                        className="h-[40px] w-[100%]"
                        value={measuringUnit}
                        onChange={(e) => setMeasuringUnit(e)}
                        options={
                          recordsMetaData ? recordsMetaData.unitOptions : []
                        }
                      />
                    </Col>

                    <Col span={12} className="pr-4 mb-2">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        {" "}
                        Opening Stock
                      </Typography>

                      <Input
                        name="openingStocks"
                        value={itemDetailsData.openingStocks}
                        onChange={(e) => handleItemChange(e)}
                        // suffix={
                        //   <div className="bg-[#e9e9e9] h-[38px] mr-[-5px] pr-[4px] pl-[4px]">
                        //     {" "}
                        //     <h1 className="mt-[-15px] h-[20px]">PCS</h1>
                        //   </div>
                        // }
                        addonAfter="PCS"
                        type="text"
                        className="item-stock"
                        placeholder="Enter Opening Stock"
                      />
                    </Col>
                    <Col span={12} className="pr-4 mb-2">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        As of Date
                      </Typography>

                      <DatePicker
                        className={
                          media == "sm"
                            ? "rounded-md border border-1 h-[40px] w-[110%] mt-1 mb-2 pl-2"
                            : media == "xs"
                            ? "rounded-md border border-1 h-[40px] w-[125%] mt-1 mb-2 pl-2"
                            : media == "xl" || media == "xxl" || media == "lg"
                            ? "rounded-md border border-1 h-[40px] w-[135%] mt-1 mb-2 pl-2"
                            : "rounded-md border border-1 h-[40px] w-[125%] pl-2"
                        }
                        toggleCalendarOnIconClick={true}
                        icon={
                          <BiCalendar
                            className={
                              media == "sm"
                                ? "top-[5px] text-[16px] right-[-133px] text-[#9e9e9e]"
                                : media == "xs"
                                ? "top-[5px] text-[16px] right-[-30px] text-[#9e9e9e]"
                                : media == "xl" ||
                                  media == "xxl" ||
                                  media == "lg"
                                ? "top-[7px] text-[16px] right-[-61px] text-[#9e9e9e]"
                                : "top-[3px] text-[16px] right-[-30px] text-[#9e9e9e]"
                            }
                          />
                        }
                        placeholderText="Select Date"
                        showIcon
                        selected={asOfDate}
                        onChange={(date) => {
                          setAsOfDate(date);
                        }}
                      />
                    </Col>
                    <Col span={12} className="pr-4 mb-2">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        Expiry Date
                      </Typography>

                      <DatePicker
                        selected={expiryDate}
                        className={
                          media == "sm"
                            ? "rounded-md border border-1 h-[40px] w-[110%] mt-1 mb-2 pl-2"
                            : media == "xs"
                            ? "rounded-md border border-1 h-[40px] w-[125%] mt-1 mb-2 pl-2"
                            : media == "xl" || media == "xxl" || media == "lg"
                            ? "rounded-md border border-1 h-[40px] w-[135%] mt-1 mb-2 pl-2"
                            : "rounded-md border border-1 h-[40px] w-[125%] pl-2"
                        }
                        toggleCalendarOnIconClick={true}
                        icon={
                          <BiCalendar
                            className={
                              media == "sm"
                                ? "top-[5px] text-[16px] right-[-133px] text-[#9e9e9e]"
                                : media == "xs"
                                ? "top-[5px] text-[16px] right-[-30px] text-[#9e9e9e]"
                                : media == "xl" ||
                                  media == "xxl" ||
                                  media == "lg"
                                ? "top-[7px] text-[16px] right-[-61px] text-[#9e9e9e]"
                                : "top-[3px] text-[16px] right-[-30px] text-[#9e9e9e]"
                            }
                          />
                        }
                        showIcon
                        onChange={(date) => {
                          setExpiryDate(date);
                        }}
                        placeholderText="Select Expiry Date"
                      />
                    </Col>
                    <Col span={12} className="pr-4 mb-2">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        MFG Date
                      </Typography>

                      <DatePicker
                        selected={mfgDate}
                        className={
                          media == "sm"
                            ? "rounded-md border border-1 h-[40px] w-[110%] mt-1 mb-2 pl-2"
                            : media == "xs"
                            ? "rounded-md border border-1 h-[40px] w-[125%] mt-1 mb-2 pl-2"
                            : media == "xl" || media == "xxl" || media == "lg"
                            ? "rounded-md border border-1 h-[40px] w-[135%] mt-1 mb-2 pl-2"
                            : "rounded-md border border-1 h-[40px] w-[125%] pl-2"
                        }
                        toggleCalendarOnIconClick={true}
                        icon={
                          <BiCalendar
                            //   size={30}

                            className={
                              media == "sm"
                                ? "top-[5px] text-[16px] right-[-33px] text-[#9e9e9e]"
                                : media == "xs"
                                ? "top-[5px] text-[16px] right-[-30px] text-[#9e9e9e]"
                                : media == "xl" ||
                                  media == "xxl" ||
                                  media == "lg"
                                ? "top-[7px] text-[16px] right-[-61px] text-[#9e9e9e]"
                                : "top-[3px] text-[16px] right-[-30px] text-[#9e9e9e]"
                            }
                          />
                        }
                        showIcon
                        onChange={(date) => {
                          setMfgDate(date);
                        }}
                        placeholderText="Select Mfg Date"
                      />
                    </Col>
                  </Row>
                </Col>
              ) : menuSelected === "Serialisation" && serialisation === true ? (
                <Col
                  style={{
                    pointerEvents: !isEmpty(updatedData) ? "none" : "",
                    opacity: !isEmpty(updatedData) ? 2 : "",
                  }}
                  span={24}
                >
                  <Row>
                    <Col span={12} className="pr-4 mb-2">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        {" "}
                        Opening Stock
                      </Typography>

                      <Input
                        name="serialOpenStock"
                        value={serialOpenStock}
                        onChange={(e) => setSerialOpenStock(e.target.value)}
                        // suffix={
                        //   <div className="bg-[#e9e9e9] h-[38px] mr-[-5px] pr-[6px] pl-[6px]">
                        //     {" "}
                        //     <h1 className="mt-[-15px] h-[20px]">PCS</h1>
                        //   </div>
                        // }
                        type="text"
                        className="item-stock"
                        addonAfter="PCS"
                        placeholder="Enter Opening Stock"
                      />
                    </Col>
                    <Col span={12} className="pr-4 mb-2">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1"
                      >
                        Measuring Unit
                      </Typography>
                      <Select
                        placeholder="Select Unit"
                        className="h-[40px] w-[100%]"
                        value={measuringUnit}
                        onChange={(e) => setMeasuringUnit(e)}
                        options={
                          recordsMetaData ? recordsMetaData.unitOptions : []
                        }
                      />
                    </Col>
                    <Col span={24} className="pr-4 mb-2">
                      <div>
                        <table className="table-serial table-responsive">
                          <thead>
                            <tr className="table-row">
                              <th className="table-head">IMEI/Serial No</th>
                              <th className="table-head">Date Created</th>
                              <th className="table-head"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {serialData.map((data, index) => {
                              return (
                                <tr key={index} className="">
                                  <td className="table-data flex justify-between">
                                    <Input
                                      name="serialNo"
                                      value={data.fieldName}
                                      placeholder="Enter Custom Field name"
                                      // className="w-[90%]"
                                      onChange={(e) =>
                                        handleSerialDataChange(
                                          e,
                                          "serialNo",
                                          index
                                        )
                                      }
                                    />
                                  </td>
                                  <td className="table-data">{data.date}</td>
                                  <td className="table-data">
                                    {" "}
                                    <DeleteOutlined
                                      onClick={() => removeSerialData(index)}
                                      type="primary"
                                      className="ml-3 p-2 cursor-pointer"
                                      size={"large"}
                                    />{" "}
                                  </td>
                                </tr>
                              );
                            })}

                            <tr>
                              <td className="table-data">
                                <div
                                  onClick={() => addSerialData()}
                                  className="cursor-pointer text-[#1677ff]"
                                >
                                  <PlusOutlined className="mr-2" />
                                  Add New Serial No
                                </div>
                              </td>
                              <td className="table-data" colSpan={2}>
                                <div className="flex">
                                  <BiQrScan className="mr-2 mt-1" />
                                  <p>Scan Serial No</p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Col>
                  </Row>
                </Col>
              ) : menuSelected === "Stock Details" ? (
                <Col
                  style={{
                    pointerEvents: !isEmpty(updatedData) ? "none" : "",
                    opacity: !isEmpty(updatedData) ? 2 : "",
                  }}
                  span={24}
                >
                  <Row className="mt-3">
                    <Col span={12} className="pr-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        Item Code
                      </Typography>

                      <Input
                        name="itemCode"
                        value={itemDetailsData.itemCode}
                        onChange={(e) => handleItemChange(e)}
                        suffix={
                          <div
                            onClick={() => {
                              api
                                .post("/org/generatebarcode")
                                .then((res) => {
                                  setItemDetailsData({
                                    ...itemDetailsData,
                                    itemCode: res.data.barcodeId,
                                  });
                                  return res.data;
                                })
                                .catch((error) => Promise.reject(error));
                            }}
                            className="cursor-pointer p-[6px] mr-[-11px] bg-[#e7f4fd]"
                          >
                            <h1 className="text-[#1677ff]">Generate Barcode</h1>
                          </div>
                        }
                        type="text"
                        className="pr-[12px] pl-1 pt-0 pb-0"
                        placeholder="Ex: ITM3765"
                      />
                    </Col>

                    <Col span={12} className="pr-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        HSN Code
                      </Typography>

                      <Input
                        name="hsnCode"
                        value={itemDetailsData.hsnCode}
                        onChange={(e) => handleItemChange(e)}
                        type="text"
                        className="p-2"
                        placeholder="ex: 3050"
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col span={24} className="pr-4">
                      <Row>
                        <Col span={12} className="pr-4">
                          <Typography
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="text-[#667085] mb-1"
                          >
                            Measuring Unit
                          </Typography>
                          <Select
                            placeholder="Select Unit"
                            value={measuringUnit}
                            onChange={(e) => setMeasuringUnit(e)}
                            className="h-[40px] w-[100%]"
                            options={
                              recordsMetaData ? recordsMetaData.unitOptions : []
                            }
                          />
                        </Col>
                      </Row>

                      {alternativeUnit === true ? (
                        <Row className="mt-4 bg-[#ededed] pt-3 pb-3 rounded-md">
                          <Col span={12} className="pl-4 pr-4">
                            <Typography
                              style={{
                                fontFamily: "Poppins",
                              }}
                              className="text-[#667085] mb-1"
                            >
                              Secondary Unit
                            </Typography>
                            <Select
                              placeholder="Select Secondary Unit"
                              className="h-[40px] w-[100%]"
                              value={secondaryMeasuringUnit}
                              onChange={(e) => setSecondaryMeasuringUnit(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.unitOptions
                                  : []
                              }
                            />
                          </Col>
                          <Col span={12} className="pr-4">
                            <Typography
                              style={{
                                fontFamily: "Poppins",
                              }}
                              className="text-[#667085] mb-1 flex"
                            >
                              {" "}
                              Conversion Rate
                            </Typography>

                            <Input
                              name="conversionsRate"
                              value={itemDetailsData.conversionsRate}
                              onChange={(e) => handleItemChange(e)}
                              prefix={
                                <div className="bg-[#e9e9e9] h-[38px] ml-[-5px] pt-[2px] pb-[2px]">
                                  {" "}
                                  <h1 className="mt-[-15px] h-[20px]">
                                    1 PCS=
                                  </h1>
                                </div>
                              }
                              suffix={
                                <div className="bg-[#e9e9e9] h-[38px] mr-[-5px] pr-[4px] pl-[4px]">
                                  {" "}
                                  <h1 className="mt-[-15px] h-[20px]">Unit</h1>
                                </div>
                              }
                              type="text"
                              className="item-stock"
                              placeholder="Enter Conversion Rate"
                            />
                          </Col>
                          <div
                            onClick={() => setAlternativeUnit(false)}
                            className="cursor-pointer ml-5 mr-2 mb-2 text-[#1677ff]"
                          >
                            <CloseOutlined className="mr-2" />
                            Remove Alternative Unit
                          </div>
                        </Row>
                      ) : (
                        <div
                          onClick={() => setAlternativeUnit(true)}
                          className="cursor-pointer mt-2 mr-2 mb-2 text-[#1677ff]"
                        >
                          <PlusOutlined className="mr-2" /> Alternative Unit
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col span={12} className="pr-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        Opening Stock
                      </Typography>

                      <Input
                        name="stocksOpenings"
                        value={itemDetailsData.stocksOpenings}
                        onChange={(e) => handleItemChange(e)}
                        // suffix={
                        //   <div className="p-[6px] bg-[lightgray] mr-[-11px] rounded-r-2">
                        //     PCS
                        //   </div>
                        // }
                        addonAfter="PCS"
                        type="text"
                        className="pr-[12px] h-[40px] pl-1 mt-1 pt-0 pb-0"
                        placeholder="ex: 150PCS"
                      />
                    </Col>
                    <Col span={12} className="pr-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        As of Date
                      </Typography>

                      <DatePicker
                        selected={asOfDate}
                        className={
                          media == "sm"
                            ? "rounded-md border border-1 h-[40px] w-[110%] mt-1 mb-2 pl-2"
                            : media == "xs"
                            ? "rounded-md border border-1 h-[40px] w-[125%] mt-1 mb-2 pl-2"
                            : media == "xl" || media == "xxl" || media == "lg"
                            ? "rounded-md border border-1 h-[40px] w-[135%] mt-1 mb-2 pl-2"
                            : "rounded-md border border-1 h-[40px] w-[125%] pl-2"
                        }
                        toggleCalendarOnIconClick={true}
                        icon={
                          <BiCalendar
                            //   size={30}

                            className={
                              media == "sm"
                                ? "top-[5px] text-[16px] right-[-133px] text-[#9e9e9e]"
                                : media == "xs"
                                ? "top-[5px] text-[16px] right-[-30px] text-[#9e9e9e]"
                                : media == "xl" ||
                                  media == "xxl" ||
                                  media == "lg"
                                ? "top-[7px] text-[16px] right-[-61px] text-[#9e9e9e]"
                                : "top-[3px] text-[16px] right-[-30px] text-[#9e9e9e]"
                            }
                          />
                        }
                        placeholderText="Select Date"
                        showIcon
                        onChange={(date) => {
                          setAsOfDate(date);
                        }}
                      />
                    </Col>
                  </Row>

                  {lowStock === true ? (
                    <Row className="mt-4 bg-[#ededed] bg-[#ededed] pt-3 pb-3 rounded-md">
                      <Col span={24}>
                        <Row>
                          <Col span={13} className="pl-4 pr-8">
                            <Typography
                              style={{
                                fontFamily: "Poppins",
                              }}
                              className="text-[#667085] mb-1 flex"
                            >
                              Low Stock Quantity
                            </Typography>

                            <Input
                              name="lowStockQuantity"
                              value={itemDetailsData.lowStockQuantity}
                              onChange={(e) => handleItemChange(e)}
                              addonAfter="PCS"
                              type="text"
                              className="item-stock"
                              placeholder="Enter Low Stock Quantity"
                            />
                          </Col>
                        </Row>
                        <div
                          onClick={() => setLowStock(false)}
                          className="cursor-pointer mt-2 ml-4 mb-2 text-[#1677ff]"
                        >
                          <CloseOutlined className="mr-2" />
                          Remove Low stock quantity warning
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <div
                      onClick={() => setLowStock(true)}
                      className="cursor-pointer mt-2 mr-2 mb-2 text-[#1677ff]"
                    >
                      <PlusOutlined className="mr-2" />
                      Enable Low stock quantity warning
                    </div>
                  )}
                  <Row>
                    <Col span={24} className="mt-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        Description
                      </Typography>

                      <Input.TextArea
                        name="description"
                        value={itemDetailsData.description}
                        onChange={(e) => handleItemChange(e)}
                        type="text"
                        className="h-[70px]"
                        placeholder="Enter Description"
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2 mb-2">
                    <Col span={24} className="p-2 mt-4">
                      <Dragger
                        onChange={onChange}
                        {...draggerProps}
                        // onPreview={true}
                      >
                        <p className="ant-upload-drag-icon">
                          <CloudUploadOutlined />
                        </p>
                        <p className="ant-upload-text">
                          Click or drag file to this area to upload
                        </p>
                        <p className="ant-upload-hint">
                          Support for a single or bulk upload. Strictly
                          prohibited from uploading company data or other banned
                          files.
                        </p>
                      </Dragger>
                      {/* <div className="flex">
                          <CloudUploadOutlined className="text-[26px]" />

                          <div className="ml-2">
                            <h1 className="mt-1 mb-1 text-[14px] font-semibold">
                              {" "}
                              Please select or drag and drop files.
                            </h1>
                            <p className="text-[12px]">
                              {" "}
                              Maximum of 5 images in PNG or JPEG, file size no
                              more than 5 MB
                            </p>
                          </div>
                        </div>
                        

                       
                        <div className="rounded-md cursor-pointer mt-1 h-[40px] font-semibold bg-[#e7f4fd] pt-2 pb-2 pr-6 pl-6 hover:border hover:border-blue-500 text-[#0c8ce9]">
                          <Upload
                            action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                            listType="picture"
                            className=""
                            // maxCount={1}
                            fileList={fileList}
                            onChange={onChange}
                          >
                            {fileList.length < 3 && "+ Select File"}
                          </Upload>
                          
                        </div> */}
                    </Col>
                  </Row>
                </Col>
              ) : menuSelected === "Other Details" ? (
                <Col
                  style={{
                    pointerEvents: !isEmpty(updatedData) ? "none" : "",
                    opacity: !isEmpty(updatedData) ? 2 : "",
                  }}
                  span={24}
                >
                  <Row>
                    <Col span={12} className="pr-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        SAC Code
                      </Typography>

                      <Input
                        name="sacCode"
                        value={itemDetailsData.sacCode}
                        onChange={(e) => handleItemChange(e)}
                        type="text"
                        className="p-2"
                        placeholder="Enter SAC Code"
                      />
                    </Col>
                    <Col span={24} className="mt-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        Description
                      </Typography>

                      <Input.TextArea
                        name="serviceDescription"
                        value={itemDetailsData.serviceDescription}
                        onChange={(e) => handleItemChange(e)}
                        type="text"
                        className="h-[120px] p-4"
                        placeholder="Enter Description"
                      />
                    </Col>
                  </Row>
                </Col>
              ) : (
                <Col span={24}>
                  <Row
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="mt-3"
                  >
                    <Col
                      style={{
                        pointerEvents: !isEmpty(updatedData) ? "none" : "",
                        opacity: !isEmpty(updatedData) ? 2 : "",
                      }}
                      span={12}
                      className="pr-4"
                    >
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        {" "}
                        Item Type
                        <p className="text-[red] text-[12px] ml-1">*</p>
                      </Typography>
                      <Radio.Group
                        className="flex"
                        value={itemType}
                        onChange={(e) => setItemType(e.target.value)}
                      >
                        <div className="flex">
                          <Typography
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="mb-1 mr-2"
                          >
                            Product
                          </Typography>
                          <Radio value={"Product"}></Radio>
                        </div>
                        <div className="flex ml-[20px]">
                          <Typography
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="mb-1 mr-2"
                          >
                            Service
                          </Typography>
                          <Radio value={"Service"}></Radio>
                        </div>
                      </Radio.Group>
                      <p className="text-start text-[red] mt-2 mb-3">
                        {simpleValidator.current.message(
                          "itemType",
                          itemType,
                          "required"
                        )}
                      </p>
                    </Col>
                    <Col
                      style={{
                        pointerEvents: !isEmpty(updatedData) ? "none" : "",
                        opacity: !isEmpty(updatedData) ? 2 : "",
                      }}
                      span={12}
                      className="pr-4"
                    >
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1"
                      >
                        {/* Category */} Brand
                      </Typography>
                      <Select
                        style={{
                          width: 250,
                          height: 40,
                        }}
                        value={brandList}
                        onChange={(e) => setBrandList(e)}
                        suffixIcon={<SearchOutlined className="text-[12px]" />}
                        onSearch={true}
                        placeholder="Select Brand"
                        dropdownRender={(menu) => (
                          <>
                            {menu}
                            <Divider
                              style={{
                                margin: "8px 0",
                              }}
                            />
                            <div className="w-[100%]">
                              <Button
                                type="dashed"
                                className="w-[100%]"
                                icon={<PlusOutlined />}
                                onClick={() => {
                                  setCategoryAdditionalFields(false);
                                  setItemCategoryModal(true);
                                }}
                              >
                                Add Brand
                              </Button>
                            </div>
                          </>
                        )}
                        options={brandOptions}
                      />
                      {/* <Select
                        style={{
                          width: 250,
                          height: 40,
                        }}
                        value={itemCategory}
                        onChange={(e) => setItemCategory(e)}
                        suffixIcon={<SearchOutlined className="text-[12px]" />}
                        onSearch={true}
                        placeholder="Select Categories"
                        dropdownRender={(menu) => (
                          <>
                            {menu}
                            <Divider
                              style={{
                                margin: "8px 0",
                              }}
                            />
                            <div className="w-[100%]">
                              <Button
                                type="dashed"
                                className="w-[100%]"
                                icon={<PlusOutlined />}
                                onClick={() => {
                                  setCategoryAdditionalFields(false);
                                  setItemCategoryModal(true);
                                }}
                              >
                                Add item
                              </Button>
                            </div>
                          </>
                        )}
                        options={categoryOptions}
                      /> */}
                      {/* <p className="text-start text-[red] mt-2 mb-3">
                        {simpleValidator.current.message(
                          "itemCategory",
                          itemCategory,
                          "required"
                        )}
                      </p> */}
                      <p className="text-start text-[red] mt-2 mb-3">
                        {simpleValidator.current.message(
                          "brandList",
                          brandList,
                          "required"
                        )}
                      </p>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    {/* <Col span={12} className="pr-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        {" "}
                        Brand
                        <p className="text-[red] text-[12px] ml-1">*</p>
                      </Typography>

                      <Select
                        style={{
                          width: 250,
                          height: 40,
                        }}
                        value={brandList}
                        onChange={(e) => setBrandList(e)}
                        // suffixIcon={<SearchOutlined className="text-[12px]" />}
                        onSearch={true}
                        placeholder="Select Brand"
                        dropdownRender={(menu) => (
                          <>
                            {menu}
                            <Divider
                              style={{
                                margin: "8px 0",
                              }}
                            />
                            
                          </>
                        )}
                        options={brandOptions}
                      />
                      <p className="text-start text-[red] mt-2 mb-3">
                        {simpleValidator.current.message(
                          "brandList",
                          brandList,
                          "required"
                        )}
                      </p>
                    </Col> */}
                    <Col span={12} className="pr-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        {" "}
                        Item Name
                        <p className="text-[red] text-[12px] ml-1">*</p>
                      </Typography>

                      <Input
                        placeholder={
                          itemType !== "Service"
                            ? "ex: Biscuits"
                            : "ex: Phone service"
                        }
                        className="p-2"
                        name="itemName"
                        value={itemDetailsData.itemName}
                        onChange={(e) => handleItemChange(e)}
                      />
                      <p className="text-start text-[red] mt-2 mb-3">
                        {simpleValidator.current.message(
                          "itemName",
                          itemDetailsData.itemName,
                          "required"
                        )}
                      </p>
                    </Col>
                    <Col
                      style={{
                        pointerEvents: !isEmpty(updatedData) ? "none" : "",
                        opacity: !isEmpty(updatedData) ? 2 : "",
                      }}
                      span={12}
                      className="pr-4"
                    >
                      <div className="flex justify-between flex mt-10">
                        <Typography
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="text-[#667085] mb-1 mr-2"
                        >
                          {" "}
                          Show Item in Online Store
                        </Typography>
                        <Switch
                          value={showOnlineStore}
                          onChange={(checked) => setShowOnlineStore(checked)}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row
                    style={{
                      pointerEvents: !isEmpty(updatedData) ? "none" : "",
                      opacity: !isEmpty(updatedData) ? 2 : "",
                    }}
                    className="mt-3"
                  >
                    <Col span={12} className="pr-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1 flex"
                      >
                        {" "}
                        Sales Price
                      </Typography>

                      <Input
                        name="salesPrice"
                        value={itemDetailsData.salesPrice}
                        onChange={(e) => handleItemChange(e)}
                        addonAfter={
                          <Select
                            value={salesPriceMode}
                            onChange={(e) => setSalesPriceMode(e)}
                            defaultValue={"With Tax"}
                            style={{
                              width: 130,
                              height: 40,
                            }}
                            options={[
                              {
                                label: "With Tax",
                                value: "With Tax",
                              },

                              {
                                label: "Without Tax",
                                value: "Without Tax",
                              },
                            ]}
                          />
                        }
                        type="text"
                        prefix={"₹ "}
                        placeholder="ex: ₹100"
                        style={{
                          padding: "5px",
                        }}
                      />
                    </Col>
                    <Col span={12} className="pr-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1"
                      >
                        GST Tax Rate(%)
                      </Typography>
                      <Select
                        placeholder="Select Tax"
                        className="h-[35px] w-[100%]"
                        value={gstRate}
                        onChange={(e) => setGstRate(e)}
                        options={
                          recordsMetaData
                            ? recordsMetaData.gstPercentageOptions
                            : []
                        }
                      />
                    </Col>
                  </Row>
                  <Row
                    style={{
                      pointerEvents: !isEmpty(updatedData) ? "none" : "",
                      opacity: !isEmpty(updatedData) ? 2 : "",
                    }}
                    className="mt-3"
                  >
                    <Col span={12} className="pr-4">
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[#667085] mb-1"
                      >
                        Measuring Unit
                      </Typography>
                      <Select
                        placeholder="Select Unit"
                        className="h-[40px] w-[100%]"
                        value={measuringUnit}
                        onChange={(e) => setMeasuringUnit(e)}
                        options={
                          recordsMetaData ? recordsMetaData.unitOptions : []
                        }
                      />
                    </Col>
                    {itemType !== "Service" ? (
                      <Col span={12} className="pr-4">
                        <Typography
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="text-[#667085] mb-1 flex"
                        >
                          {" "}
                          Opening Stock
                        </Typography>

                        <Input
                          name="openingStocks"
                          value={itemDetailsData.openingStocks}
                          onChange={(e) => handleItemChange(e)}
                          addonAfter={"PCS"}
                          type="text"
                          className="item-stock"
                          placeholder="ex: 150PCS"
                        />
                      </Col>
                    ) : (
                      <Col span={12} className="pr-4">
                        <Typography
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="text-[#667085] mb-1 flex"
                        >
                          {" "}
                          Service Code
                        </Typography>

                        <Input
                          name="serviceCode"
                          value={itemDetailsData.serviceCode}
                          onChange={(e) => handleItemChange(e)}
                          addonAfter={"PCS"}
                          type="text"
                          className="p-2"
                          placeholder="Enter Service Code"
                        />
                      </Col>
                    )}
                  </Row>
                  {itemType !== "Service" ? (
                    <Row
                      style={{
                        pointerEvents: !isEmpty(updatedData) ? "none" : "",
                        opacity: !isEmpty(updatedData) ? 2 : "",
                      }}
                      className="mt-2 bg-[lightgray] rounded-md"
                    >
                      <Col span={12} className="pl-4 pr-4 mt-[-25px]">
                        <div
                          style={{
                            pointerEvents: serialisation === true ? "none" : "",
                            opacity: serialisation === true ? 1 : "",
                          }}
                          className="flex mb-3 p-2 ml-1  rounded-md bg-[#ffffff] justify-between flex mt-10"
                        >
                          <div className="flex">
                            <Typography
                              style={{
                                fontFamily: "Poppins",
                              }}
                              className="text-[#667085] mb-1 mr-2"
                            >
                              {" "}
                              Enable Batching
                            </Typography>
                            <Tooltip
                              title="Manage stock batch-wise to keep track of different prices, expiry dates, and manufacturing dates"
                              placement="top"
                            >
                              <InfoCircleOutlined />{" "}
                            </Tooltip>
                          </div>
                          <Switch
                            value={batching}
                            onChange={(checked) => {
                              if (checked === true) {
                                setMenuSelected("Batch Details");
                              }
                              setBatching(checked);
                            }}
                            disabled={serialisation === true ? true : false}
                          />
                        </div>
                      </Col>
                      <Col span={12} className="pr-4 mt-[-25px]">
                        <div
                          style={{
                            pointerEvents: batching === true ? "none" : "",
                            opacity: batching === true ? 1 : "",
                          }}
                          className="flex  mb-3 p-2 rounded-md mr-1  bg-[#ffffff]  justify-between flex mt-10"
                        >
                          <div className="flex">
                            <Typography
                              style={{
                                fontFamily: "Poppins",
                              }}
                              className="text-[#667085] mb-1 mr-2"
                            >
                              {" "}
                              Enable Serialization
                            </Typography>
                            <Tooltip
                              title="Assign Serial Numbers/IMEI to track individual pieces of stock."
                              placement="topLeft"
                            >
                              <InfoCircleOutlined />{" "}
                            </Tooltip>
                          </div>
                          <Switch
                            value={serialisation}
                            disabled={batching === true ? true : false}
                            onChange={(checked) => {
                              if (checked === true) {
                                setMenuSelected("Serialisation");
                              }
                              setSerialisation(checked);
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                </Col>
              )}
            </Col>
          </Row>
        </Col>
        <Modal
          open={itemSettings}
          title="Add Custom Fields"
          onOk={() => setItemSettings(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          // okButtonProps={{
          //   disabled: customFieldsData.length > 0 ? false : true,
          // }}
          width={550}
          className="mt-[-90px]"
          style={{
            fontFamily: "Poppins",
          }}
          onCancel={() => setItemSettings(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.1px", width: "110%", marginLeft: "-24px" }}
          />
          <div className="mb-1 flex justify-between mt-[-15px] mb-[-13px]">
            <h1 className="mt-2">Stock Value Calculation</h1>
            <Select
              style={{
                width: 170,
                height: 40,
              }}
              value={stockValue}
              onChange={(e) => setStockValue(e)}
              placeholder=""
              options={[
                {
                  label: "Purchase Price",
                  value: "Purchase Price",
                },
                {
                  label: "Sales Price",
                  value: "Sales Price",
                },
              ]}
            />
          </div>
          <Divider style={{ width: "110%", marginLeft: "-24px" }} />
          <div className="mt-[-15px] flex justify-between">
            <div>
              <h1 className="text-[14px] font-semibold">
                Enable Item Batching & Expiry
              </h1>
              <p className="mt-1 text-[12px]">
                Keep track of multiple prices, expiry and manufacturing dates
              </p>
            </div>
            <Switch
              className="mt-3"
              value={itemBatching}
              onChange={(checked) => setItemBatching(checked)}
            />
          </div>
          {itemBatching === true ? (
            <>
              <div className="mt-[10px] mb-[-13px] flex justify-between">
                <h1 className="text-[14px] font-semibold">
                  Alert Before Expiry
                </h1>
                <Switch
                  className="mt-3"
                  value={beforeExpiry}
                  onChange={(checked) => setBeforeExpiry(checked)}
                />
              </div>
              {beforeExpiry === true ? (
                <div className="mt-[25px] mb-[-13px] flex justify-between">
                  <p className="mt-1 text-[12px]">
                    We will notify you the below selected days before your batch
                    expires
                  </p>
                  <Select
                    style={{
                      width: 120,
                      height: 35,
                      fontFamily: "Poppins ",
                    }}
                    value={validity}
                    onChange={(e) => setValidity(e)}
                    placeholder=""
                    suffixIcon={<p className="font-semibold">Days</p>}
                    options={[
                      {
                        label: "30 Days",
                        value: "30 Days",
                      },
                      {
                        label: "60 Days",
                        value: "60 Days",
                      },
                      {
                        label: "90 Days",
                        value: "90 Days",
                      },
                    ]}
                  />
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          <Divider style={{ width: "110%", marginLeft: "-24px" }} />
          <div className="mb-[-13px] flex justify-between">
            <div>
              <h1 className="text-[14px] font-semibold">
                Enable Serial Number/IMEI
              </h1>
              <p className="mt-1 text-[12px]">
                Manage your items by Serial Number or IMEI and track them easily
              </p>
            </div>
            <Switch
              className="mt-3"
              value={serialNumber}
              onChange={(checked) => setSerialNumber(checked)}
            />
          </div>
          {serialNumber === true ? (
            <div className="mt-[10px]">
              <Typography
                style={{
                  fontFamily: "Poppins",
                }}
                className="mt-1 text-[#667085] mb-1"
              >
                Field Name
              </Typography>
              <Input
                name="serialNumberFields"
                value={serialNumberFields}
                onChange={(e) => setSerialNumberFields(e.target.value)}
                placeholder="Enter a serial number"
                className="p-3 mt-[10px] w-[50%]"
              />
              <p className="mt-1 text-[12px]">
                Choose a custom field name like IMEI Number, Model Number, Part
                Number etc. for adding the serial numbers.
              </p>
            </div>
          ) : (
            ""
          )}

          <Divider style={{ width: "110%", marginLeft: "-24px" }} />
          <div className="mt-[-15px] mb-[-13px] flex justify-between">
            <h1 className="text-[14px] font-semibold">MRP</h1>
            <Switch className="mt-3" />
          </div>
          <Divider style={{ width: "110%", marginLeft: "-24px" }} />
          <div className="mt-[-15px] mb-[-13px] flex justify-between">
            <h1 className="text-[14px] font-semibold">Wholesale Price</h1>
            <Switch className="mt-3" />
          </div>
          <Divider style={{ width: "110%", marginLeft: "-24px" }} />
          <div className="mt-[-15px] mb-[-13px]">
            {customFieldsData.map((data, index) => {
              return (
                <div key={index} className="mb-2">
                  <div className="flex justify-between mb-[10px]">
                    <h1>{data.fieldName}</h1>
                    <p
                      onClick={() => removeCustomFields(index)}
                      type="primary"
                      className="ml-3 p-2 text-[red] cursor-pointer"
                      size={"large"}
                    >
                      Delete
                    </p>{" "}
                  </div>
                </div>
              );
            })}
          </div>
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Row
            style={{
              fontFamily: "Poppins",
            }}
            onClick={() => setCustomFields(true)}
            className="w-[100%] mt-2 bg-gray-50 p-2 pl-5 pr-5 mt-3 mb-3"
          >
            <h1 className="cursor-pointer text-[14px] text-[#084d7b] font-semibold">
              {" "}
              <PlusOutlined /> Add Custom Field
            </h1>
          </Row>
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
        <Modal
          open={customFields}
          title="Add Custom Fields"
          onOk={handleOk}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: customFieldsData.length > 0 ? false : true,
          }}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <div className="w-[110%] ml-[-23.5px] mt-[-24px] mb-4">
            <Image src={customModalLogo} />
          </div>
          <div>
            <Typography
              style={{
                fontFamily: "Poppins",
              }}
              className="text-[#667085] mb-2"
            >
              Field Name
            </Typography>
            {customFieldsData.map((data, index) => {
              return (
                <div key={index} className="mb-2">
                  <div className="flex justify-between mb-[10px]">
                    <Input
                      name="fieldName"
                      value={data.fieldName}
                      placeholder="Enter Custom Field name"
                      className="w-[90%]"
                      addonAfter={
                        <>
                          {invoiceShow === true ? (
                            <Tooltip
                              title="Visible in Invoice"
                              placement="left"
                            >
                              <EyeFilled
                                onClick={() => setInvoiceShow(false)}
                              />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Hidden in Invoice" placement="left">
                              <EyeInvisibleFilled
                                onClick={() => setInvoiceShow(true)}
                              />
                            </Tooltip>
                          )}
                        </>
                      }
                      onChange={(e) =>
                        handleCustomFieldsChange(e, "fieldName", index)
                      }
                    />
                    <DeleteOutlined
                      onClick={() => removeCustomFields(index)}
                      type="primary"
                      className="ml-3 border rounded-md p-2 text-[red] cursor-pointer"
                      size={"large"}
                    />{" "}
                  </div>
                </div>
              );
            })}
          </div>
          {/* ) : (
            ""
          )} */}

          <Row
            onClick={() => addCustomFields()}
            className="w-[100%] mt-2 bg-gray-50 p-2 border border-dashed border-blue-400 pl-5 pr-5 mt-3 mb-3"
          >
            <h1 className="cursor-pointer text-[14px] text-[#084d7b] font-semibold">
              {" "}
              <PlusOutlined /> Add Custom Field
            </h1>
          </Row>
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
        <Divider
          style={{
            borderWidth: "0.2px",
            width: "105.9%",
            marginLeft: "-24px",
          }}
        />
      </Modal>

      {/* New category modal */}
      <Modal
        open={itemCategoryModal}
        title={"Create Brand"}
        onOk={() => {
          createCategory();
        }}
        closeIcon
        maskClosable={false}
        okButtonProps={{
          disabled: isCategoryButtonDisabled ? true : false,
        }}
        okText={"Save"}
        width={450}
        onCancel={() => setItemCategoryModal(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
      >
        <Divider
          style={{
            borderWidth: "0.2px",
            marginTop: "1px",
            width: "112%",
            marginLeft: "-24px",
          }}
        />
        <Col span={24} className="mt-[-5px]">
          <Typography
            className="uppercase mb-1"
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
            }}
          >
            Brand Name
          </Typography>
          <Input
            name="categoryName"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            placeholder="Enter Brand Name"
            className="p-2"
          />
          <p className="text-start text-[red] mt-2 mb-3">
            {categoryValidations === true
              ? "category name field is required"
              : ""}
          </p>
        </Col>
        {categoryAdditionalFields ? (
          <>
            {" "}
            <Col span={24} className="flex justify-end">
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                onClick={() => setCategoryAdditionalFields(false)}
                className="cursor-pointer text-[#d54041] text-[13px]"
              >
                Remove
              </div>
            </Col>
            <Col span={24}>
              <Typography
                className="uppercase mb-1"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                Short Code
              </Typography>
              <Input
                name="shortCode"
                value={shortCode}
                onChange={(e) => setShortCode(e.target.value)}
                placeholder="Enter Short Code"
                className="p-2"
              />
            </Col>
            <Col span={24} className="mb-[50px] mt-2">
              <Typography
                className="uppercase mb-1"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                Description
              </Typography>
              <Input.TextArea
                name="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter Description"
                className="p-3"
              />
            </Col>
          </>
        ) : (
          <div
            style={{
              fontFamily: "Poppins",
            }}
            onClick={() => setCategoryAdditionalFields(true)}
            className="cursor-pointer flex text-[#4096ff] mt-2 text-[13px] mb-4"
          >
            <PlusOutlined className="mr-2" /> Additonal Fields
          </div>
        )}
      </Modal>
      <Prompt
        when={!isEmpty(asOfDate)}
        message="Are you sure you want to leave?"
      />
      {/* <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        // closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        // pauseOnHover
        theme="dark"
      /> */}
    </div>
  );
};

CreateItems.propTypes = {
  onSignin: PropTypes.any,
  itemCreated: PropTypes.any,
  updatedItemValues: PropTypes.any,
  recordsMetaData: PropTypes.any,
  modalOpen: PropTypes.any,
  mode: PropTypes.any,
  routeName: PropTypes.any,
  data: PropTypes.any,
  modalClose: PropTypes.func,
};

export default CreateItems;
